import React from 'react'

const SvgQuoteLeft = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 12c1.644 0 3 1.334 3 3.023S9.601 18 8 18s-3-1.001-3-3.971C5 9.534 6.333 6.858 9 6h2c-3.976 1.985-3.253 6-3 6zm8 0c1.644 0 3 1.334 3 3.023S17.601 18 16 18s-3-1.001-3-3.971C13 9.534 14.333 6.858 17 6h2c-3.976 1.985-3.253 6-3 6z'
    />
  </svg>
)

export default SvgQuoteLeft
